import type { IAuthSDK } from '../base-client/AuthSDK';
import type { Options } from 'ky';

import { getInstallId } from '@/shared/helpers/getInstallId';
import { MMBaseClient } from '../base-client/MMBaseClient';
import { MMGatewayConfig } from './config';
import { useAuthSDK } from '~/features/auth-sdk';

const { authSDKController } = useAuthSDK();

export class MMGatewayClient extends MMBaseClient {
  constructor() {
    super(MMGatewayConfig.getBaseUrl(), authSDKController);

    this.kyInstance = this.kyInstance.extend((options: Options) => ({
      headers: {
        ...options.headers,
        'x-service': MMGatewayConfig.DEFAULT_HEADERS.XService,
        'x-device-id': getInstallId(),
        'X-Device-Platform': MMGatewayConfig.DEFAULT_HEADERS.XDevicePlatform,
        'x-app-type': MMGatewayConfig.DEFAULT_HEADERS.XAppType,
        'X-Store-Code': MMGatewayConfig.DEFAULT_HEADERS.XStoreCore,
      },
    }));
  }
}
